import {
  ArrowLeftOutlined,
  BellOutlined,
  DownloadOutlined,
  LockOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Badge, Button, Col, Dropdown, Empty, Menu, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { DarkModeSwitch } from "react-toggle-dark-mode";
import { toast } from "react-toastify";
import getUserFromToken from "../../utils/getUserFromToken";
import getRoleIdFromToken from "../../utils/getRoleIdByToken";
import styles from "./Header.module.css";
import {
  addWebAppAttendance,
  EmployeeLastPunchGet,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import { loadPendingNotifications } from "../../redux/rtk/features/notification/notificationSlice";
import { loadSingleStaff } from "../../redux/rtk/features/user/userSlice";
import appleStoreImage from "../../assets/appleStore.png";
import playStoreImage from "../../assets/playStore.webp";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

function Header({ onPress, collapsed, handleCollapsed }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const isLogged = localStorage.getItem("isLogged");
  const user = localStorage.getItem("user");
  const userId = getUserFromToken();
  const roleId = getRoleIdFromToken();
  const RequirePasswordChange = localStorage.getItem("RequirePasswordChange");
  // console.log("passwordChanged", RequirePasswordChange);

  // // console.log("user in header", user)
  const navigate = useNavigate();

  const items = [
    {
      key: "1",
      label: (
        <p
          style={{ margin: 0, padding: "0.2rem 0.5rem" }}
          className="flex align-items-center p-0.5"
        >
          <Link to={`/admin/hr/staffs/${userId}`}>
            <UserOutlined style={{ fontSize: "16px" }} />{" "}
            <span className="logout-text font-weight-bold me-2 ms-1">
              {user}
            </span>
          </Link>
        </p>
      ),
    },
    {
      key: "2",
      label: (
        <p
          style={{ margin: 0, padding: "0.2rem 0.5rem" }}
          className="flex align-items-center p-0.5"
        >
          <Link to="/admin/resetPassword" >
            <LockOutlined style={{ fontSize: "16px" }}  />
            <span className="logout-text font-weight-bold">Change Password</span>
          </Link>
        </p>
      ),
    },
    {
      key: "3",
      label: (
        <p
          style={{ margin: 0, padding: "0.2rem 0.5rem" }}
          className="flex align-items-center"
        >
          
          <Link to="/admin/auth/logout" className={styles.logoutLink}>
          
            <LogoutOutlined className="text-danger" />
            <span className="logout-text font-weight-bold">Log Out</span>
          </Link>
        </p>
      ),
    },
  ];

  const [isDarkMode, setDarkMode] = useState(false);
  const [isPunching, setIsPunching] = useState(false);
  const [isPunchedIn, setIsPunchedIn] = useState(false);
  const [hasMobileId, setHasMobileId] = useState(false);

  const dispatch = useDispatch();
  const { list: notificationList = [], loading: notificationLoading } = useSelector(
    (state) => state.notification || {}
  );
  const notificationMeta = useSelector((state) => state.notification?.meta);
  const lastPunch = useSelector((state) => state.attendance?.lastPunch);
  const attendanceLoading = useSelector((state) => state.attendance?.loading);
  const currentUser = useSelector((state) => state.users.user);
  const userLoading = useSelector((state) => state.users.loading);
  // console.log("lastPunch", lastPunch);
  const toggleDarkMode = (checked) => {
    setDarkMode(checked);
  };

  useEffect(() => {
    if (isDarkMode) document.body.className = "dark-theme";
    if (!isDarkMode) document.body.className = "light-theme";
  }, [isDarkMode]);

  // Fetch last punch on load to determine button state
  useEffect(() => {
    // console.log("Header - Initial load, fetching last punch data...");
    dispatch(EmployeeLastPunchGet()).then((result) => {
      // console.log("Header - Initial last punch fetch result:", result);
    }).catch((error) => {
      // console.error("Header - Initial last punch fetch error:", error);
    });
  }, []);

  // Fetch current user data to check for MobileId
  useEffect(() => {
    if (userId && isLogged) {
      dispatch(loadSingleStaff(userId));
    }
  }, [userId, isLogged]);

  useEffect(() => {
    if (isLogged) {
      // Use 0 to fetch all reporting pending requests (as per API example)
      dispatch(loadPendingNotifications(0));
    }
  }, [dispatch, isLogged]);

  // Debug logging for notifications
  useEffect(() => {
    console.log('Header - Notification state:', {
      notificationList,
      notificationListLength: notificationList?.length,
      notificationLoading,
      notificationMeta
    });
  }, [notificationList, notificationLoading, notificationMeta]);

  // Check if user has MobileId
  useEffect(() => {
    const mobileId = currentUser?.EmployeesDetail?.[0]?.MobileId;
  
    // Check if MobileId exists and is not empty/null
    if (mobileId && mobileId.trim() !== '') {
      setHasMobileId(true);
      // console.log("Header - User HAS MobileId, hiding punch button");
    } else {
      setHasMobileId(false);
      // console.log("Header - User does NOT have MobileId, showing punch button");
    }
  }, [currentUser]);

  // Derive current punched-in status from last punch data
  useEffect(() => {
    // console.log("Header - Last punch data changed:", lastPunch);
    
    if (lastPunch) {
      // Accept both wrapped and direct shapes
      const lp = lastPunch?.data || lastPunch;
      
      
      // Prefer HasPunchIn/HasPunchOut if provided by API; fallback to IsPunchIn/IsPunchOut
      const hasIn = lp?.HasPunchIn ?? (lp?.IsPunchIn ? 1 : 0);
      const hasOut = lp?.HasPunchOut ?? (lp?.IsPunchOut ? 1 : 0);
      const currentlyIn = Boolean(Number(hasIn) === 1 && Number(hasOut) === 0);
      
     
      
      setIsPunchedIn(currentlyIn);
    } else {
      // console.log("Header - No last punch data available");
      setIsPunchedIn(false);
    }
  }, [lastPunch]);

  // Items are already filtered in the slice, so just use them directly
  // But add a safety check just in case
  const pendingNotifications = Array.isArray(notificationList)
    ? notificationList.filter((item) => {
        // Double-check: items should already be filtered, but verify
        const statusText = String(item?.status || item?.approvalStatus || '').toLowerCase();
        const statusId = Number(item?.LeaveStatusId ?? item?.raw?.LeaveStatusId ?? 0);
        
        // Only show pending items (already filtered in slice, but double-check)
        return statusText === 'pending' || statusId === 3;
      })
    : [];

  // Debug logging for filtered notifications
  useEffect(() => {
    console.log('Header - Notification Summary:', {
      notificationListLength: notificationList?.length,
      notificationList: notificationList,
      pendingNotificationsCount: pendingNotifications?.length,
      pendingNotifications: pendingNotifications,
      notificationLoading,
      notificationMeta
    });
  }, [pendingNotifications, notificationList, notificationLoading, notificationMeta]);

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadUserApp = () => {
    downloadFile("/MobileApkLink/app-release.apk");
  };

  const handlePlayStoreClick = () => {
    window.open("https://play.google.com/store/apps/details?id=com.softomation.hrms_project", "_blank");
  };

  const handleAppleStoreClick = () => {
    window.open("https://apps.apple.com/app/hrms360/id6751835203", "_blank");
  };

  const handleNotificationVisibleChange = (visible) => {
    setNotificationDropdownVisible(visible);
    if (visible) {
      // Load notifications when dropdown opens (on hover)
      dispatch(loadPendingNotifications(0));
    }
  };

  const getNotificationTitle = (notification) =>
    notification?.title ||
    notification?.Title ||
    notification?.subject ||
    notification?.Subject ||
    notification?.message ||
    notification?.Message ||
    (notification?.type === "leave"
      ? "Leave request"
      : notification?.type === "expense"
      ? "Expense request"
      : "Pending notification");

  const getNotificationMeta = (notification) => {
    const typeLabel =
      notification?.type ||
      notification?.Type ||
      notification?.module ||
      notification?.Module ||
      notification?.entityType ||
      "Request";

    const createdOn =
      notification?.createdAt ||
      notification?.CreatedAt ||
      notification?.created_on ||
      notification?.Created_On;

    if (createdOn) {
      try {
        return `${typeLabel} • ${new Date(createdOn).toLocaleDateString()}`;
      } catch (e) {
        return typeLabel;
      }
    }

    return typeLabel;
  };

  const resolveNotificationLink = (notification) => {
    const type = (
      notification?.type ||
      notification?.Type ||
      notification?.module ||
      notification?.Module ||
      notification?.entityType ||
      ""
    )
      .toString()
      .toLowerCase();

    const refId =
      notification?.refId ??
      notification?.entityId ??
      notification?.EntityId ??
      notification?.referenceId ??
      notification?.ReferenceId ??
      notification?.targetId ??
      notification?.TargetId ??
      notification?.id;

    console.log('resolveNotificationLink:', {
      notification,
      type,
      refId,
      refIdType: typeof refId
    });

    let route = "/admin/dashboard";
    
    switch (type) {
      case "leave":
      case "leaveapplication":
        route = refId ? `/admin/leave/${refId}` : "/admin/leave";
        break;
      case "expense":
      case "expenseclaim":
        route = refId ? `/admin/expense/${refId}` : "/admin/expense";
        break;
      case "travel":
      case "travelrequest":
        route = "/admin/travelStatus";
        break;
      case "loan":
        route = "/admin/loanStatus";
        break;
      case "meeting":
        route = refId ? `/admin/meeting/${refId}` : "/admin/meetings";
        break;
      case "resignation":
        route = "/admin/resignation/approvals";
        break;
      default:
        route = "/admin/dashboard";
    }
    
    console.log('Resolved route:', route);
    return route;
  };

  const [notificationDropdownVisible, setNotificationDropdownVisible] = useState(false);

  const handleNotificationClick = (notification) => {
    console.log('Notification clicked:', {
      notification,
      refId: notification?.refId,
      type: notification?.type,
      raw: notification?.raw
    });
    
    const targetRoute = resolveNotificationLink(notification);
    console.log('Resolved route:', targetRoute);
    
    // Close dropdown immediately
    setNotificationDropdownVisible(false);
    
    if (targetRoute) {
      // Navigate immediately - same as view button in GetAllLeaves
      // Pass the raw notification data as state (similar to view button)
      navigate(targetRoute, {
        state: { 
          leaveData: notification?.raw,
          notificationData: notification 
        }
      });
    } else {
      toast.info("No detail page configured for this notification yet.");
    }
  };

  const getCurrentPosition = () =>
    new Promise((resolve) => {
      if (!navigator.geolocation) {
        // console.warn("Geolocation is not supported by this browser");
        return resolve({ error: { code: 0, message: "unsupported" } });
      }
      try {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            // console.log("Geolocation success");
            resolve({ coords: pos.coords });
          },
          (err) => {
            // console.warn("Geolocation error:", err?.code, err?.message);
            resolve({ error: err });
          },
          { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
      } catch (e) {
        // console.warn("Geolocation exception:", e?.message || e);
        resolve({ error: e });
      }
    });



  const handlePunch = async (type) => {
    try {
      setIsPunching(true);
      // console.log("Punch click:", type, "EmployeeId:", userId || "N/A");
      const { coords, error } = await getCurrentPosition();
      if (coords && typeof coords.latitude === "number" && typeof coords.longitude === "number") {
        // console.log("Latitude:", coords.latitude, "Longitude:", coords.longitude);
      } else {
        // console.log("Location not available", error || null);
      }

      const payload = {
        Latitude: coords?.latitude || null,
        Longitude: coords?.longitude || null,
        IsPunchIn: type === "in" ? 1 : 0,
        IsPunchOut: type === "out" ? 1 : 0,
      };

      try {
        const action = await dispatch(addWebAppAttendance(payload)).unwrap();
        // console.log("Header - Punch action result:", action);
        
        if (action?.message === "success") {
          // console.log("Header - Punch successful, refreshing data...");
          
          // Add small delay to ensure server has processed the punch
          await new Promise(resolve => setTimeout(resolve, 500));
          
          // Force refresh the last punch data multiple times to ensure it updates
          // console.log("Header - Force refreshing EmployeeLastPunchGet...");
          let refreshSuccess = false;
          
          for (let attempt = 1; attempt <= 3; attempt++) {
            try {
              // console.log(`Header - Refresh attempt ${attempt}/3`);
              
              // Call EmployeeLastPunchGet
              const punchAction = await dispatch(EmployeeLastPunchGet());
              // console.log(`Header - Attempt ${attempt} result:`, punchAction);
              
              // Check if the action was successful
              if (punchAction.type.endsWith('/fulfilled')) {
                // console.log(`Header - Attempt ${attempt} successful, data:`, punchAction.payload);
                refreshSuccess = true;
                break;
              } else {
                // console.log(`Header - Attempt ${attempt} failed, trying again...`);
                await new Promise(resolve => setTimeout(resolve, 300));
              }
            } catch (refreshError) {
              // console.error(`Header - Attempt ${attempt} error:`, refreshError);
              if (attempt < 3) {
                await new Promise(resolve => setTimeout(resolve, 300));
              }
            }
          }
          
          if (refreshSuccess) {
            // Also refresh user data
            try {
              const userAction = await dispatch(loadSingleStaff(userId));
              // console.log("Header - User data refresh result:", userAction);
            } catch (userError) {
              // console.error("Header - User data refresh failed:", userError);
            }
            
            toast.success(`Successfully punched ${type === "in" ? "in" : "out"}!`);
          } else {
            // console.error("Header - All refresh attempts failed, falling back to page reload");
            toast.error("Punch successful but failed to refresh data. Reloading page...");
            
            // Fallback to page reload
            setTimeout(() => {
              // console.log("Header - Falling back to page reload");
              window.location.reload();
            }, 1000);
          }
        } else {
          // console.log("Header - Punch action failed:", action);
          toast.error("Failed to punch attendance. Please try again.");
        }
      } catch (error) {
        // Handle API errors from addWebAppAttendance
        // console.error("Header - Punch error:", error);
        
        let message = "Error in adding Attendance. Try again.";
        
        // Handle 409 Conflict error specifically
        if (error?.response?.status === 409) {
          message = "You have already punched in/out for today. Please check your attendance status.";
          // console.log("Header - 409 Conflict: User already punched in/out");
        } else if (Array.isArray(error) && error.length > 0) {
          message = error[0]?.message || message;
        } else if (error?.message) {
          message = error.message;
        } else if (typeof error === "string") {
          message = error;
        }
        
        toast.error(message);
        
        // ALWAYS refresh punch data after any error to get current status
        // console.log("Header - Refreshing punch data after error...");
        setTimeout(() => {
          dispatch(EmployeeLastPunchGet()).then((result) => {
            // console.log("Header - Punch data refreshed after error:", result);
          }).catch((refreshError) => {
            // console.error("Header - Error refreshing punch data:", refreshError);
          });
        }, 1000);
      }
    } finally {
      setIsPunching(false);
    }
  };

  const notificationMenu = (
    <Menu className={styles.notificationMenu}>
      <Menu.Item key="title" disabled>
        <div className={styles.notificationMenuHeader}>Pending notifications</div>
      </Menu.Item>

      {notificationLoading ? (
        <Menu.Item key="loading" disabled>
          <div className={styles.notificationLoading}>
            <Spin size="small" />
            <span>Loading...</span>
          </div>
        </Menu.Item>
      ) : pendingNotifications.length ? (
        pendingNotifications.map((item, index) => (
          <Menu.Item
            key={item?.NotificationId || item?.id || item?.Id || index}
            onClick={() => handleNotificationClick(item)}
          >
            <div className={styles.notificationItem}>
              <div className={styles.notificationItemTitle}>
                {getNotificationTitle(item)}
              </div>
              <div className={styles.notificationItemMeta}>
                {getNotificationMeta(item)}
              </div>
            </div>
          </Menu.Item>
        ))
      ) : (
        <Menu.Item key="empty" disabled>
          <div className={styles.notificationEmpty}>
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="No pending notifications"
            />
          </div>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={24} md={4}>
          <div className={styles.headerLeftGroup}>
            <div className={styles.sidebarTogglerPC}>
              {isLogged &&
                React.createElement(
                  collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                  {
                    className: `${styles.trigger}`,
                    onClick: () => handleCollapsed(!collapsed),
                  }
                )}
            </div>
            {isLogged && (
              <Button
                type="text"
                icon={<ArrowLeftOutlined />}
                onClick={() => navigate(-1)}
                className={styles.backButton}
                title="Go back"
                aria-label="Go back"
              />
            )}
          </div>
        </Col>
        <Col span={24} md={20} className={styles.headerControl}>
          {/* Punch In/Out Button - Commented out */}
          {/* {(() => {
            const shouldShowButton = isLogged && !hasMobileId && !userLoading;
            // console.log("Header - Button render logic:", {
              isLogged,
              hasMobileId,
              userLoading,
              shouldShowButton,
              currentUser: currentUser?.EmployeesDetail?.[0]
            });
            
                        return shouldShowButton && (
              <Button
                className={isPunchedIn ? styles.punchOut : styles.punchIn}
                loading={isPunching}
                disabled={isPunching}
                onClick={() => handlePunch(isPunchedIn ? "out" : "in")}
                style={{
                  marginRight: 8,
                  backgroundColor: isPunchedIn ? "#ff4d4f" : "#52c41a",
                  borderColor: isPunchedIn ? "#ff4d4f" : "#52c41a",
                  color: "#fff",
                }}
              >
                {isPunchedIn ? "Punch Out" : "Punch In"}
              </Button>
            );
          })()} */}
          {isLogged && (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <img
                src={playStoreImage}
                alt="Play Store"
                onClick={handlePlayStoreClick}
                style={{
                  height: "40px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  transition: "transform 0.2s ease-in-out"
                }}
                onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                onMouseOut={(e) => e.target.style.transform = "scale(1)"}
              />
              <img
                src={appleStoreImage}
                alt="Apple Store"
                onClick={handleAppleStoreClick}
                style={{
                  height: "40px",
                  cursor: "pointer",
                  borderRadius: "4px",
                  transition: "transform 0.2s ease-in-out"
                }}
                onMouseOver={(e) => e.target.style.transform = "scale(1.05)"}
                onMouseOut={(e) => e.target.style.transform = "scale(1)"}
              />
            </div>
          )}
          {isLogged && (
            <Dropdown
              overlay={notificationMenu}
              placement="bottomRight"
              trigger={["hover"]}
              open={notificationDropdownVisible}
              onOpenChange={handleNotificationVisibleChange}
              mouseEnterDelay={0.2}
              mouseLeaveDelay={0.1}
            >
              <Button
                type="text"
                style={{ marginRight: 8 }}
                aria-label="Notifications"
              >
                <Badge
                  count={pendingNotifications.length}
                  size="small"
                  overflowCount={99}
                >
                  <BellOutlined style={{ fontSize: 18 }} />
                </Badge>
              </Button>
            </Dropdown>
          )}
          <DarkModeSwitch
            style={{ margin: "1rem" }}
            checked={isDarkMode}
            onChange={toggleDarkMode}
            size={20}
          />

          {/* {isLogged && (
            <Typography.Title
              level={5}
              style={{ margin: 0 }}
              className="me-3 flex align-items-center"
            >
              <UserOutlined style={{ fontSize: "16px" }} />{" "}
              <span className="logout-text font-weight-bold me-2 ms-1">
                {user}
              </span>
            </Typography.Title>
          )} */}

          {!isLogged && (
            <Link to="/admin/auth/login" className="btn-sign-in text-dark">
              <span></span>
            </Link>
          )}

          {isLogged && (
            <Button
              type="link"
              className={styles.sidebarTogglerMobile}
              onClick={() => onPress()}
              style={{ boxShadow: "none" }}
            >
              {toggler}
            </Button>
          )}
          {isLogged && (roleId === 1 || roleId === 2) && (
            <Button
              type="default"
              icon={<DownloadOutlined />}
              href="/hrm360admindocument/HRMS Admin.pdf"
              download="HRMS_Admin_Manual.pdf"
              target="_blank"
              style={{ 
                marginRight: "8px",
                display: "flex",
                alignItems: "center"
              }}
              title="Download Admin Manual"
            >
              Admin Manual
            </Button>
          )}
          {isLogged && (
            <div>
              {RequirePasswordChange !== "true" && (
              <Dropdown
                overlay={<Menu items={items} />}
                placement="bottomLeft"
                className="user-dropdown"
              >
                <Button className="user-btn">
                  <UserOutlined style={{ fontSize: "16px" }} />
                </Button>
              </Dropdown>
              )}
            </div>
          )}
        </Col>
      </Row>
    </>
  );
}

export default Header;
